import 'stylesheets/pages/event/online_salon/about/style';
import SmoothScroll from 'smooth-scroll';

new SmoothScroll('a[href*="#"]', {
  easing: 'easeInOutCubic',
  offset: 20,
  updateURL: false,
  popstate: true,
});
